import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { CommentState } from '../../state/states/comment.state';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommentReplyEventInput } from '../../state/inputs/comment-reply-event.input';
import { MarkdownService } from '../../../markdown/markdown.service';
import { Subject } from 'rxjs';
import { Giphy } from '../giphy/giphy.component';

@Component({
  selector: 'reply-comment-section',
  templateUrl: './reply-comment-section.component.html',
  styleUrls: ['./reply-comment-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReplyCommentSectionComponent implements OnInit {
  commentGroup: FormGroup;

  @Input() commentState: CommentState;
  @Input() currentUser: MiniUserModel;
  @Input() hideActionButtons: Boolean = false;

  @Output() createReplyCommentEvent = new EventEmitter<
    CommentReplyEventInput
  >();
  @Output() hideReplyCommentsEvent = new EventEmitter();

  @Output() loadMoreReplyCommentsEvent = new EventEmitter();

  @Output() upVoteReplyCommentEvent = new EventEmitter<string>();
  @Output() downVoteReplyCommentEvent = new EventEmitter<string>();
  @Output() deleteReplyCommentEvent = new EventEmitter<string>();

  set = 'twitter';

  replyEmojiEvent = new Subject<string>();

  @ViewChild('replyGifEmojiTrigger') emojiTrigger;

  constructor(
    private _formBuilder: FormBuilder,
    private markdownService: MarkdownService
  ) {
    this.commentGroup = this.createCommentGroup();
  }

  ngOnInit(): void {}

  createCommentGroup(): FormGroup {
    return this._formBuilder.group({
      comment: ['', Validators.compose([Validators.required])]
    });
  }

  createReplyComment(): void {
    this.createReplyCommentEvent.emit({
      comment: this.markdownService.convert(
        this.commentGroup.get('comment').value
      ),
      commentId: this.commentState?.comment?.Id
    });

    this.commentGroup.reset();
  }

  addEmoji(event) {
    const emo = event.emoji.native;
    this.replyEmojiEvent.next(emo);
  }

  selectedGiphy(gif: Giphy): void {
    this.createReplyCommentEvent.emit({
      comment: ' ',
      commentId: this.commentState?.comment?.Id,
      images: [gif.images?.downsized_medium?.url]
    });

    this.emojiTrigger.closeMenu();
  }

  scrollReplyComments(): void {}

  upVoteReplyComment(replyCommentID: string): void {
    this.upVoteReplyCommentEvent.emit(replyCommentID);
  }

  deleteReplyComment(replyCommentID: string): void {
    this.deleteReplyCommentEvent.emit(replyCommentID);
  }

  downVoteReplyComment(replyCommentID: string): void {
    this.downVoteReplyCommentEvent.emit(replyCommentID);
  }

  hideReplyComments(): void {
    this.hideReplyCommentsEvent.emit();
  }

  loadMoreReplyComments(): void {
    this.loadMoreReplyCommentsEvent.emit();
  }
}
